import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetConfig = () => axios.get(apiPaths.configBase);

const onUpdateConfig = (jsonConfig) => axios.put(apiPaths.configBase, jsonConfig);

export { onGetConfig, onUpdateConfig };
